import { Stack as MaterialStack } from '@mui/material'

const Stack = MaterialStack

export { Stack }
